module.exports = "---\ntitle: \"磁贴\"\ntime: \"2024-09-25\"\n---\n\n\"glance and go\"，内容作为主体，碎片化，可见度高。恰巧是对小记这一风格的最好诠释\n";